var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "get-action": _vm.queryApi,
          serial: _vm.serial,
          selection: _vm.selection,
          stripe: false,
          "search-btn-hide": "",
          "right-toolbar-hide": "",
          "no-auto-height": "",
          "auto-scroll": false,
          "row-key": "BJ_EBC_ID",
          "reset-data": _vm.resetDataFn,
          lazy: "",
          load: _vm.loadMethod,
          "row-style": _vm.treeRowStyleFun,
          "check-method": _vm.checkMethod,
        },
        on: {
          handleTableDataChange: _vm.handleTableDataChange,
          handleSelectionChange: _vm.handleSelectionChange,
        },
        scopedSlots: _vm._u([
          {
            key: "tableColumn",
            fn: function () {
              return [
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.name"),
                    prop: "skuName",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.SKU"),
                    prop: "standardSkuCode",
                    align: "center",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.SPU"),
                    prop: "batchNumList",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("BjSelectLov", {
                            attrs: {
                              "option-list": scope.row.batchNumList,
                              placeholder: _vm.$t(
                                "OrdinaryOrderMix.OrderItemTable.SPU"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: scope.row.spuCode,
                              callback: function ($$v) {
                                _vm.$set(scope.row, "spuCode", $$v)
                              },
                              expression: "scope.row.spuCode",
                            },
                          }),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.Quantity"),
                    prop: "quantity",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          !scope.row.isChildSku
                            ? _c("BjInputNumber", {
                                staticClass: "full-width",
                                attrs: {
                                  maxlength: _vm.MAX_LENGTH.DEFAULT,
                                  min: 0,
                                  precision: 0,
                                  controls: false,
                                  onkeyup:
                                    "this.value = this.value.replace(/[^\\d]/g,'').replace(/^0{1,}/g,'')",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.onBlurQuantity(scope.row)
                                  },
                                },
                                model: {
                                  value: scope.row.quantity,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "quantity", $$v)
                                  },
                                  expression: "scope.row.quantity",
                                },
                              })
                            : _vm._e(),
                          scope.row.isChildSku
                            ? _c("span", [_vm._v(_vm._s(scope.row.num))])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t(
                      "BusinessBatchInventoryQuery.table.usableNum2"
                    ),
                    prop: "usableNum",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.batchNumList &&
                          scope.row.batchNumList.length > 0
                            ? _c("span", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.batchNumList.bjGet(
                                        scope.row.spuCode,
                                        "value",
                                        "usableNum"
                                      )
                                    ) +
                                    " "
                                ),
                              ])
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    label: _vm.$t("OrdinaryOrderMix.OrderItemTable.Operation"),
                    align: "center",
                    fixed: "right",
                    width: "120",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !scope.row.isChildSku,
                                  expression: "!scope.row.isChildSku",
                                },
                              ],
                              attrs: {
                                disabled:
                                  _vm.$route.query.orderHandleStatus == 3,
                                type: "text",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onDelete(scope.row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "OrdinaryOrderMix.OrderItemTable.Delete"
                                  )
                                )
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }